import { Injectable } from '@angular/core';
import * as crypto from 'crypto-js';

@Injectable({
  providedIn: 'root'
})
export class EmailSignerService {
  private readonly secretKey = 'ce9144434de5badef0b99f627f4e6c5a';

  constructor() {}

  /**
   * Sign an email using HMAC-SHA256
   * @param email - Email address to sign
   * @returns Hex string signature
   */
  signEmail(email: string): string {
    return crypto.HmacSHA256(email, this.secretKey).toString(crypto.enc.Hex);
  }
}
